export const overviewTileTypes = [
  'Tile::GuildMessage',
  'Tile::RaidProgress',
  'Tile::TeamDescription',
  'Tile::RosterSummary',
  'Tile::CustomLinks',
  'Tile::CustomImage',
  'Tile::CustomText',
  'Tile::SidebarTiles',
  'Tile::UpcomingEvents',
  'Tile::RecentEvents',
  'Tile::RecentNews',
  'Tile::EnchantAudit',
  'Tile::PendingApplicants',
  'Tile::TeamSummary',
  'Tile::OverviewTable',
] as const

export const skeletonHeightByTileType: Record<OverviewTileType, string> = {
  'Tile::GuildMessage': 'h-16',
  'Tile::RaidProgress': 'h-[4.1rem]',
  'Tile::TeamDescription': 'h-16',
  'Tile::RosterSummary': 'h-40',
  'Tile::CustomLinks': 'h-24',
  'Tile::CustomImage': 'h-52',
  'Tile::CustomText': 'h-20',
  'Tile::SidebarTiles': 'h-76',
  'Tile::UpcomingEvents': 'h-60',
  'Tile::RecentEvents': 'h-60',
  'Tile::RecentNews': 'h-40',
  'Tile::EnchantAudit': 'h-60',
  'Tile::PendingApplicants': 'h-40',
  'Tile::TeamSummary': 'h-64',
  'Tile::OverviewTable': 'h-100',
}

type OverviewTileType = typeof overviewTileTypes[number]
export default OverviewTileType
